module.exports = __webpack_public_path__ + "static/img/product_rules.4c81616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_rules.jpg
// module id = IH2W
// module chunks = 0